import React from 'react';

import { LoaderWrapper, StyledSVG } from './HSLoader.styled';

type HSLoaderProps = {
  size?: number;
};

export const HSLoader: React.FC<HSLoaderProps> = ({ size = 200 }) => (
  <LoaderWrapper>
    <StyledSVG
      size={size}
      viewBox="0 0 46 68"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <g clipPath="url(#clip0_260_9750)">
        <path
          className="contour"
            // eslint-disable-next-line max-len
          d="M46 22.6739C46 10.1582 35.6875 0 23.009 0C10.3306 0 0 10.1582 0 22.6739C0 28.7757 3.52179 36.6111 7.82018 43.805C14.1413 54.3792 22.0518 63.5666 22.0518 63.5666C22.2866 63.844 22.6298 64 23.009 64C23.3883 64 23.7134 63.844 23.9482 63.5666C23.9482 63.5666 27.9395 58.5569 28.8967 57.3434C29.2399 56.9274 29.276 56.5114 29.1496 56.182C28.8426 55.402 27.5964 55.0033 26.892 55.9393C25.9168 57.2048 23.9301 59.7183 23.009 60.8624C20.7515 58.1235 14.8638 50.7736 9.98744 42.5742C5.94189 35.7963 2.49234 28.429 2.49234 22.6912C2.47428 11.5103 11.6851 2.4442 23.009 2.4442C34.3329 2.4442 43.5257 11.5103 43.5257 22.6739C43.5257 24.5287 43.1645 26.5569 42.5324 28.6717C42.5324 28.6717 42.5324 28.6891 42.5324 28.7064C42.5324 28.7411 42.5324 28.7757 42.5324 28.8104C39.119 39.9393 27.8131 40.5634 24.2733 40.4074V30.4745V30.4399C24.2733 29.7638 23.7134 29.2091 23.0452 29.2091H20.0832C19.3969 29.2091 18.8371 29.7638 18.8371 30.4399C18.8371 31.1159 19.3969 31.6706 20.0832 31.6706H21.799V41.5515C21.799 42.1582 22.2505 42.6782 22.8826 42.7649C22.8826 42.7649 39.444 44.8797 44.519 30.7519C45.4943 27.8917 46.0542 25.1528 46.0542 22.6912L46 22.6739Z"
        />
        <path
          fill="#C18344"
            // eslint-disable-next-line max-len
          d="M23.0107 18.2014C25.5211 18.2014 27.58 20.2123 27.58 22.6911C27.58 25.17 25.5392 27.1808 23.0107 27.1808C20.4822 27.1808 18.4414 25.17 18.4414 22.6911C18.4414 20.2123 20.4822 18.2014 23.0107 18.2014ZM23.0107 20.5936C21.8368 20.5936 20.8796 21.5297 20.8796 22.6911C20.8796 23.8526 21.8368 24.7886 23.0107 24.7886C24.1846 24.7886 25.1418 23.8526 25.1418 22.6911C25.1418 21.5297 24.1846 20.5936 23.0107 20.5936Z"
        />
        <path
          className="contour2"
          fill="#C18344"
          strokeWidth={0.2}
            // eslint-disable-next-line max-len
          d="M29.999 49.2134C32.5274 49.2134 34.5683 51.2242 34.5683 53.7031C34.5683 56.182 32.5274 58.1928 29.999 58.1928C27.4705 58.1928 25.4297 56.182 25.4297 53.7031C25.4297 51.2242 27.4705 49.2134 29.999 49.2134ZM29.999 51.6056C28.8251 51.6056 27.8679 52.5417 27.8679 53.7031C27.8679 54.8645 28.8251 55.8006 29.999 55.8006C31.1729 55.8006 32.1301 54.8645 32.1301 53.7031C32.1301 52.5417 31.1729 51.6056 29.999 51.6056Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_260_9750">
          <rect width="46" height="64" fill="white" />
        </clipPath>
      </defs>
    </StyledSVG>
  </LoaderWrapper>
);
